import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaProductHunt, FaRegListAlt, FaKey, FaUsers, FaUserAlt, FaCog } from 'react-icons/fa';
import { SlGraph } from "react-icons/sl";
import { MdCampaign } from "react-icons/md";
import { TiFlowMerge } from "react-icons/ti";
import { BsPeopleFill } from "react-icons/bs";
import './style.css';

const Sidebar = () => {
    const location = useLocation();

    return (
        <div className="sidebar-container">
            <Link to="/" className={`sidebar-item ${location.pathname === '/' ? 'active' : ''}`}>
                <MdCampaign className="sidebar-icon" />
                <p className="sidebar-text">Campaign</p>
            </Link>
            <Link to="/flows" className={`sidebar-item ${location.pathname === '/flows' ? 'active' : ''}`}>
                <TiFlowMerge className="sidebar-icon" />
                <p className="sidebar-text">Flows</p>
            </Link>
            <Link to="/audience" className={`sidebar-item ${location.pathname === '/flows' ? 'active' : ''}`}>
                <BsPeopleFill className="sidebar-icon" />
                <p className="sidebar-text">Audience</p>
            </Link>
            <Link to="/dashboard" className={`sidebar-item ${location.pathname === '/dashboard' ? 'active' : ''}`}>
                <SlGraph className="sidebar-icon" />
                <p className="sidebar-text">Dashboard</p>
            </Link>
        </div>
    );
};

export { Sidebar };
